import { useQuery } from "@tanstack/react-query";
import { accountsApi } from "@/lib/api";
import { buildAccountTree } from "@/lib/accounts";
import { useOrganizationStore } from "@/stores/organizationStore";
import type { AccountTreeNode } from "@/types";

interface UseChartOfAccountsReturn {
  tree: AccountTreeNode[];
  currency: string;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export const useChartOfAccounts = (): UseChartOfAccountsReturn => {
  const { currentLabel } = useOrganizationStore();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["chart-of-accounts", currentLabel?.id],
    queryFn: async () => {
      const response = await accountsApi.getChartOfAccounts(currentLabel!.id);
      return buildAccountTree(response.results);
    },
    enabled: !!currentLabel,
  });

  return {
    tree: data ?? [],
    currency: currentLabel?.currency ?? "USD",
    isLoading,
    isError,
    error,
  };
};
